export const getCustomSelectStyles = () => {
    const isMobile = typeof window !== 'undefined' && window.innerWidth < 992;

    return {
        control: (provided, state) => ({
            ...provided,
            width: '100%',
            borderRadius: 13,
            marginTop: 5,
            borderColor: state.isFocused ? '#f57c00' : '#ced4da',
            boxShadow: 'none',
            transition: 'border 0.4s ease-in-out',
            marginBottom: isMobile ? '30px' : (provided.marginBottom || 0),
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: '0px 7px',
            paddingTop: isMobile ? '2px' : provided.paddingTop || 0,
        }),
        placeholder: (provided) => ({
            ...provided,
            color: '#d1d5dc',
        }),
        menu: (provided) => ({
            ...provided,
            borderRadius: 13,
            overflow: 'hidden'
        }),
        menuPortal: (provided) => ({
            ...provided,
            zIndex: 200000,
        }),
        option: (provided, state) => ({
            ...provided,
            padding: '8px 12px',
            backgroundColor: state.isSelected ? '#f57c00' : state.isFocused ? '#fde3b7' : 'white',
            color: state.isSelected ? 'white' : 'inherit',
        }),
    };
};
